<template>
  <div class="c-accordian">
    <ul class="c-accordian__items">
      <li class="c-accordian__item">
        <button
          v-if="showTitle"
          class="c-accordian__title"
          :aria-expanded="(active) ? 'true' : 'false'"
          role="button"
          @click="active = !active"
        >
          <span
            class="l-flex l-flex--justify-between" 
          >
            <h3 :class="titleClass">
              {{ title }} 
            </h3>
            <!-- <span :class="stateClass" /> -->
            <slot name="secondary-label" />
          </span>
          <svg 
            width="11" 
            height="8" 
            viewBox="0 0 11 8" 
            fill="none"
            class="c-accordian__icon"
            :style="`${active ? 'transform: rotate(180deg)' :''}`"
          >
            <path
              d="M5.5 7.07002L0 1.57002L1.1 0.47002L5.5 4.87002L9.9 0.47002L11 1.57002L5.5 7.07002Z"
              fill="#022840"
            />
          </svg>
        </button>
        <transition name="slide">
          <button
            v-if="active"
            class="c-accordian__content"
            :class="!showTitle ? 'c-accordian__content--no-title' : ''"
            role="paragraph"
          >
            <slot />
          </button>
        </transition>
      </li>
    </ul>
  </div>
</template>

<script>
import isMobile from '@mixins/isMobile';

export default {
  name: 'Accordion',
  mixins: [
    //this.isMobile is true screen width < 900px
    isMobile
  ],
  props: {
    textAlignment: {
      type: String,
      default: "left"
    },
    mobileTextAlignment: {
      type: String,
      default: "left"
    },
    title: {
      type: String,
      default: null
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    titleTypography: {
      type: String,
      default: "t-heading-7"
    },
    titleColor: {
      type: String,
      default: ""
    },
    startingState: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      active: true,
    }
  },
  computed: {
    stateClass() {
      if (this.active) {
        return 'c-accordian__state u-margin-bottom-small c-accordian__state--closed';
      } else {
        return 'c-accordian__state u-margin-bottom-small c-accordian__state--open';
      }
    },
    titleClass() {
      let results = [''];
      results.push(this.titleTypography);
      if (this.titleColor) {
        results.push(this.titleTypography + '--' + this.titleColor);
      }
      if (this.isMobile) {
        if (this.mobileTextAlignment) {
          results.push("u-text-align-" + this.mobileTextAlignment)
        }
      } else {
        results.push("u-text-align-" + this.textAlignment)
      }
      return results;
    }

  },
  created() {
    this.active = this.startingState;
  }
};
</script>

<style lang="scss" scoped>
.c-accordian {
  padding: $filter-padding;

  &__items {
    list-style-type: none;
  }
  &__title {
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: block;
    width: 100%;
    text-align: left;
    position: relative;
    padding-right: 12px;
  }
  &__icon {
    position: absolute;
    right: 2px;
    height: 12px;
    top: 20%;
    // transform: translateY(-100%);

    &:after, &:before {
      content: "";
      position: absolute;
      top: 20%;
      right: 50%;
      width: 12px;
      height: 2px;
      margin-top: -1px;
      margin-left: -6px;
      transition: transform .3s;
      @include themify($themes){
        background-color: themed('accent');
      }
    }

    &--open:after {
      transform: rotate(90deg);
    }
  }

  &__content {
    width: 100%;
    border: 0px;
    padding-top: rem(20px);
    @include themify($themes) {
      background-color: themed('background', 'base');
    }
    text-align: left;
  }
  &__content--no-title {
    padding-top: 0;
  }
}
</style>
